function Header(){
    return (<header>
            <img src="/images/logo-removebg-preview.png" alt="TriStar Logo" className="logo"/>
            <h1>TriStar Engineers & Services</h1>
        </header>)
}

export default Header;